/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Button Styling
   ========================================================================== */
button.a-btn::-moz-focus-inner,
input.a-btn::-moz-focus-inner {
  border: 0;
}

.a-btn {
  appearance: none;
  display: inline-block;
  box-sizing: border-box;
  padding: 0.5em 0.875em;
  border: 0;
  margin: 0;
  border-radius: 0.25em;
  cursor: pointer;
  font-size: 1em;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.1s;
}
.a-btn, .a-btn:link, .a-btn:visited {
  background-color: var(--pacific);
  color: var(--white);
}
.a-btn:hover, .a-btn.hover, .a-btn:focus, .a-btn.focus {
  background-color: var(--pacific-dark);
}
.a-btn:focus, .a-btn.focus {
  outline: 1px dotted var(--pacific);
  outline-offset: 1px;
}
.a-btn:active, .a-btn.active {
  background-color: var(--navy);
}
.a-btn--secondary, .a-btn--secondary:link, .a-btn--secondary:visited {
  background-color: var(--gray);
  color: var(--white);
}
.a-btn--secondary:hover, .a-btn--secondary.hover, .a-btn--secondary:focus, .a-btn--secondary.focus {
  background-color: var(--gray-dark);
}
.a-btn--secondary:focus, .a-btn--secondary.focus {
  outline-color: var(--gray);
}
.a-btn--secondary:active, .a-btn--secondary.active {
  background-color: var(--black);
}
.a-btn--warning, .a-btn--warning:link, .a-btn--warning:visited {
  background-color: var(--red-mid-dark);
  color: var(--white);
}
.a-btn--warning:hover, .a-btn--warning.hover, .a-btn--warning:focus, .a-btn--warning.focus {
  background-color: var(--red-dark);
}
.a-btn--warning:focus, .a-btn--warning.focus {
  outline-color: var(--red-mid-dark);
}
.a-btn--warning:active, .a-btn--warning.active {
  background-color: var(--gray-dark);
}
.a-btn--disabled, .a-btn--disabled:link, .a-btn--disabled:visited, .a-btn--disabled:hover, .a-btn--disabled.hover, .a-btn--disabled:focus, .a-btn--disabled.focus, .a-btn--disabled:active, .a-btn--disabled.active, .a-btn[disabled], .a-btn[disabled]:link, .a-btn[disabled]:visited, .a-btn[disabled]:hover, .a-btn[disabled].hover, .a-btn[disabled]:focus, .a-btn[disabled].focus, .a-btn[disabled]:active, .a-btn[disabled].active {
  background-color: var(--gray-20);
  color: var(--gray-dark);
  cursor: default;
  cursor: not-allowed;
}
.a-btn--disabled:focus, .a-btn--disabled.focus, .a-btn[disabled]:focus, .a-btn[disabled].focus {
  outline-color: var(--gray-20);
}
@media only all and (max-width: 37.5em) {
  .a-btn--full-on-xs {
    display: block;
    width: 100%;
  }
}